export default __webpack_public_path__ + "static/media/inner-intelligent-quality.b8a4eaf3.svg";